// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__jrnQa","actions":"GroupTable_actions__3UYBL","deleteModalFooter":"GroupTable_deleteModalFooter__bdRhE"};